export default __webpack_public_path__ + "static/media/LabTransfer.3225d574.svg";